import { render } from "./availablePartDamageModel.vue?vue&type=template&id=3703dfe8"
import script from "./availablePartDamageModel.vue?vue&type=script&lang=js"
export * from "./availablePartDamageModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__